//import 'ag-grid-community/styles/ag-theme-quartz.css';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

export default (props) => {
    const pageNumber = props.pageNumber;
    const pageSize = props.pageSize;
    const totalRows = props.totalRows;
    const firstRow = ((pageNumber - 1) * pageSize) + 1;
    const lastRow = pageNumber * pageSize;
    const totalPages = Math.ceil(totalRows / pageSize);
    const previousButtonDisabled = pageNumber === 1;
    const nextButtonDisabled = pageNumber === totalPages;

    const handleFirstButtonClicked = () => {
        if(previousButtonDisabled) return;
        props.changePage(1);
    }
    const handlePreviousButtonClicked = () => {
        if(previousButtonDisabled) return;
        props.changePage(pageNumber - 1);
    }
    const handleNextButtonClicked = () => {
        if(nextButtonDisabled) return;
        props.changePage(pageNumber + 1);
    }
    const handleLastButtonClicked = () => {
        if(nextButtonDisabled) return;
        props.changePage(totalPages);
    }
    
    // return ReactDOM.createPortal(
    return (
        //className="ag-theme-params-2 ag-theme-params-14 ag-theme-iconSet-5">
         <div> 
            <div className="ag-paging-panel ag-unselectable ag-focus-managed">
                <div className="ag-tab-guard ag-tab-guard-top" role="presentation" tabIndex="0"></div>
                <span className="ag-paging-page-size" data-ref="pageSizeComp"></span>
                <span className="ag-paging-row-summary-panel">
                    <span data-ref="lbFirstRowOnPage" className="ag-paging-row-summary-panel-number">{firstRow} </span>
                    <span>to </span>
                    <span data-ref="lbLastRowOnPage" className="ag-paging-row-summary-panel-number">{lastRow} </span>
                    <span>of </span>
                    <span data-ref="lbRecordCount" className="ag-paging-row-summary-panel-number">{totalRows}</span>
                </span>
                <span className="ag-paging-page-summary-panel" role="presentation">
                    <div className={`ag-button ag-paging-button ${previousButtonDisabled && "ag-disabled"}`} role="button" aria-label="First Page" tabIndex="0" aria-disabled={`${previousButtonDisabled ? "true" : "false"}`}>
                        <span onClick={handleFirstButtonClicked} disabled={previousButtonDisabled} className="ag-icon ag-icon-first" unselectable="on" role="presentation"></span>
                    </div>
                    <div data-ref="btPrevious" className={`ag-button ag-paging-button ${previousButtonDisabled && "ag-disabled"}`} role="button" aria-label="Previous Page" tabIndex="0" aria-disabled={`${previousButtonDisabled ? "true" : "false"}`}>
                        <span onClick={handlePreviousButtonClicked} className="ag-icon ag-icon-previous" unselectable="on" role="presentation"></span>
                    </div>
                    <span className="ag-paging-description">
                        <span>Page </span>
                        <span data-ref="lbCurrent" className="ag-paging-number">{pageNumber} </span>
                        <span>of </span>
                        <span data-ref="lbTotal" className="ag-paging-number">{totalPages}</span>
                    </span>
                    <div data-ref="btNext" className={`ag-button ag-paging-button ${nextButtonDisabled && "ag-disabled"}`} role="button" aria-label="Next Page" tabIndex="0" aria-disabled={`${nextButtonDisabled ? "true" : "false"}`}>
                        <span onClick={handleNextButtonClicked} disabled={nextButtonDisabled} className="ag-icon ag-icon-next" unselectable="on" role="presentation"></span>
                    </div>
                    <div data-ref="btLast" className={`ag-button ag-paging-button ${nextButtonDisabled && "ag-disabled"}`} role="button" aria-label="Last Page" tabIndex="0" aria-disabled={`${nextButtonDisabled ? "true" : "false"}`}>
                        <span onClick={handleLastButtonClicked} disabled={nextButtonDisabled} className="ag-icon ag-icon-last" unselectable="on" role="presentation"></span>
                    </div>
                </span>
                <div className="ag-tab-guard ag-tab-guard-bottom" role="presentation" tabIndex="0"></div>
            </div>
        </div>
    );
    // , targetElement);
};